<template>
  <div>
    <div class="card commodity-info">
      <div class="info van-hairline--top">
        <div class="info-header">交付期限</div>
        <van-row class="info-line">
          <van-col :span="12">
            <span class="info-title">交付开始时间：</span>
            <span class="info-value">{{listingDetail.deliveryDateStart}}</span>
          </van-col>
          <van-col :span="12">
            <span class="info-title">交付结束时间：</span>
            <span class="info-value">{{listingDetail.deliveryDateEnd}}</span>
          </van-col>
        </van-row>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "OrderDeliveryCard",
  props: {
    listingDetail: Object,
  },
  data() {
    return {
      LNGmaterialCode: this.$common.interfacePath.LngMaterialCode,
      PNGmaterialCode: this.$common.interfacePath.PngMaterialCode,
    };
  },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/styles/varibles.styl';

.card {
  margin-top: 24px;
  background: #ffffff;
  padding: 0 24px;
  font-size: 26px;

  .info {
    padding: 16px 0;

    .info-header {
      display: flex;
      justify-content: right;
      align-items: center;
      height: 88px;
      font-size: 32px;

      img {
        width: 40px;
        height: 40px;
        margin-right: 12px;
      }
    }

    .info-line {
      line-height: 54px;
      color: #666666;
    }
  }
}
</style>